import { UI_COLORS } from '../../utils/colors';
import { formatMeasure } from '../portalUtils';

/**
 * The Ordered / Actual quantity pair for a line item, shared by the purchase and sale
 * detail modals so the two tabs cannot drift apart.
 *
 * Both columns are always present, so the customer can compare what they ordered with
 * what actually shipped. The Actual column stays empty until loading is finished —
 * before that there is nothing weighed or counted to show — and once loading IS done it
 * shows the captured figures verbatim. It never falls back to the ordered numbers, so a
 * blank there honestly means "not captured" instead of quietly repeating the order.
 *
 * Each cell shows pieces above the weight/length, matching how the lines are ordered.
 */
export const QuantityPair = ({ pieces, measure, unit, piecesLabel, emptyNote }) => (
  <div className="leading-tight">
    {emptyNote ? (
      <span className="text-xs" style={{ color: UI_COLORS.TEXT.MUTED }}>{emptyNote}</span>
    ) : (
      <>
        <div className="font-semibold" style={{ color: UI_COLORS.TEXT.PRIMARY }}>
          {formatMeasure(measure, unit)}
        </div>
        <div className="text-xs" style={{ color: UI_COLORS.TEXT.SECONDARY }}>
          {formatMeasure(pieces)} {piecesLabel}
        </div>
      </>
    )}
  </div>
);

export default QuantityPair;
